'use strict';
const angular = require('angular');

/*@ngInject*/
export function QuickbooksImportService($resource) {
  return $resource('/api/quickbooks-imports/:id', {
    name: '@_id'
  },{
    indexByQuickbooksName: {
      method: 'GET',
      isArray: true,
      url: "/api/quickbooks-imports/name/:name"
    },
    queryUnassigned: {
      method: 'GET',
      isArray: true,
      url: "/api/quickbooks-imports/unassigned"
    },
    getByProperty: {
      method: 'GET',
      isArray: true,
      url: "/api/quickbooks-imports/property/:propertyId"
    },
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    createBulk: {
      method: 'POST',
      url: "/api/quickbooks-imports/bulk/:communityId/:name",
      isArray: true
    },
    getBalance: {
      method: 'GET',
      url: "/api/quickbooks-imports/balance/:propertyId"
    }
  });
}


export default angular.module('conduu.QuickbooksImportService', [])
  .factory('QuickbooksImportService', QuickbooksImportService)
  .name;



// WEBPACK FOOTER //
// ./client/components/quickbooks-import/quickbooks-import.service.js